import {Table, TablePagination, TableRow} from '@mui/material';

import { EntityPagination } from 'src/types/baseEntities';

const rowsPerPageDefault = 10;

interface PaginationBaseProps {
    entityPagination: EntityPagination | undefined,
    onPaging: (actualPage: number) => void,
    blocks?: boolean
}

function PaginationComponent(props: PaginationBaseProps) {

    return (

        // <TablePagination
        //     component="div"
        //     count={props.entityPagination?.cantRecords || 0}
        //     page={(props.entityPagination?.actualPage || 1) - 1}
        //     rowsPerPageOptions={[props.entityPagination?.pageSize || rowsPerPageDefault]}
        //     rowsPerPage={props.entityPagination?.pageSize || rowsPerPageDefault}
        //     onPageChange={(event: any | null, page: number) => props.onPaging(page + 1)} />

            <TablePagination
                rowsPerPageOptions={[props.entityPagination?.pageSize || rowsPerPageDefault]}
                labelRowsPerPage={'Filas por página'}
                count={props.entityPagination?.cantRecords || 0}
                rowsPerPage={props.entityPagination?.pageSize || rowsPerPageDefault}
                page={(props.entityPagination?.actualPage || 1) - 1}
                onPageChange={(event: any | null, page: number) => props.onPaging(page + 1)}
                onRowsPerPageChange={() => console.log('asd')}
            />
    )
}

interface PaginationProps extends PaginationBaseProps {
    isLoading?: boolean
}

export function Pagination(props: PaginationProps) {

    const hasRecords: boolean = (props.entityPagination?.cantRecords || 0) > 0;
    const isVisiblePagination: boolean = ((props.isLoading != null) && (!props.isLoading) && (hasRecords));

    return (
        (isVisiblePagination) ?
            props.blocks ?
                <Table>
                    <PaginationComponent {...props} />
                </Table>
                :
                <TableRow>
                    <PaginationComponent {...props} />

                </TableRow>
            :
            null
    )
}